const yearsList = () => {
  let list = [];
  let currentYear = new Date().getFullYear();
  let earliestYear = 1950;

  while (currentYear >= earliestYear) {
    list.push({
      label: currentYear,
      key: currentYear,
    });
    currentYear -= 1;
  }

  return list;
};

const monthsList = [
  {
    label: "1",
    key: "1",
  },
  {
    label: "2",
    key: "2",
  },
  {
    label: "3",
    key: "3",
  },
  {
    label: "4",
    key: "4",
  },
  {
    label: "5",
    key: "5",
  },
  {
    label: "6",
    key: "6",
  },
  {
    label: "7",
    key: "7",
  },
  {
    label: "8",
    key: "8",
  },
  {
    label: "9",
    key: "9",
  },
  {
    label: "10",
    key: "10",
  },
  {
    label: "11",
    key: "11",
  },
  {
    label: "12",
    key: "12",
  },
];

const daysList = () => {
  let list = [];
  let end = 31;
  let start = 1;

  while (start <= end) {
    list.push({
      label: start,
      key: start,
    });
    start += 1;
  }

  return list;
};

const genderList = [
  {
    label: "先生",
    key: "先生",
  },
  {
    label: "小姐",
    key: "小姐",
  },
];
export { yearsList, monthsList, daysList, genderList };
